import React, { useState } from 'react'
import qrImage from '../assets/qr-placeholder.jpg'

const fields = [
  { name:'name', label:'Full Name *', type:'text', placeholder:'Your full name', required:true, half:true },
  { name:'fatherName', label:"Father's / Husband's Name *", type:'text', placeholder:'Father or husband name', required:true, half:true },
  { name:'dob', label:'Date of Birth', type:'date', placeholder:'', required:false, half:true },
  { name:'marriageDate', label:'Marriage Anniversary Date', type:'date', placeholder:'', required:false, half:true },
  { name:'contact', label:'Contact No. *', type:'tel', placeholder:'Your phone number', required:true, half:true },
  { name:'email', label:'Email ID', type:'email', placeholder:'your@email.com', required:false, half:true },
  { name:'profession', label:'Profession *', type:'text', placeholder:'Your profession', required:true, half:true },
  { name:'address', label:'Address *', type:'textarea', placeholder:'Your full address', required:true, half:false },
]

export default function Donate() {
  const [form, setForm] = useState({ name:'',fatherName:'',dob:'',address:'',email:'',contact:'',marriageDate:'',profession:'' })
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value })

  const validate = () => {
    const err = {}
    if (!form.name.trim()) err.name = 'Name is required'
    if (!form.fatherName.trim()) err.fatherName = 'This field is required'
    if (!form.address.trim()) err.address = 'Address is required'
    if (!form.contact.trim()) err.contact = 'Contact is required'
    if (!form.profession.trim()) err.profession = 'Profession is required'
    return err
  }

  const submit = async e => {
    e.preventDefault()
    const err = validate()
    setErrors(err)
    if (Object.keys(err).length === 0) {
      try {
        const payload = {
          email: form.email,
          contactNumber: form.contact,
          Name: form.name,
          FatherName: form.fatherName,
          DOB: form.dob,
          Address: form.address,
          MarriageAnniversary: form.marriageDate,
          Profession: form.profession,
        }
        const res = await fetch('https://backend.sewabhartiharyana.com/api/donar/create', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        const json = await res.json()
        if (json.success) {
          setSubmitted(true)
        } else {
          alert(json.message || "Failed to submit donation details")
        }
      } catch (err) {
        alert("Server connection error. Please try again later.")
      }
    }
  }

  if (submitted) return (
    <div>
      <div className="page-header"><div className="max-w-7xl mx-auto px-2"><h1>Donate</h1><p className="breadcrumb">Home › Donate</p></div></div>
      <div className="flex flex-col items-center justify-center py-20 px-6">
        <div className="rounded-3xl overflow-hidden shadow-2xl mb-6" style={{maxWidth:'360px',width:'100%'}}>
          <img src={qrImage} alt="Donation QR Code" className="w-full"/>
        </div>
        <h3 className="text-xl font-bold mb-2 text-center" style={{fontFamily:'Playfair Display,serif',color:'var(--navy)'}}>Thank You for Your Generosity!</h3>
        <p className="text-center" style={{color:'var(--muted)'}}>Please scan the QR code above to complete your donation.</p>
        <p className="text-xs mt-3 text-center" style={{color:'var(--muted)'}}>*For 80G certificate, please contact us at sewabharti1980@gmail.com</p>
      </div>
    </div>
  )

  return (
    <div>
      <div className="page-header"><div className="max-w-7xl mx-auto px-2"><h1>Donate</h1><p className="breadcrumb">Home › Donate</p></div></div>

      <section className="py-16" style={{background:'var(--cream)'}}>
        <div className="max-w-2xl mx-auto px-6">
          <div className="rounded-3xl p-8 sm:p-10" style={{background:'white',border:'1px solid rgba(0,0,0,0.07)',boxShadow:'0 16px 50px rgba(13,27,62,0.08)'}}>
            <div className="text-center mb-8">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{background:'var(--saffron-pale)'}}>
                <svg className="w-8 h-8" fill="none" stroke="var(--saffron)" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
              </div>
              <h2 className="font-bold mb-1" style={{fontFamily:'Playfair Display,serif',fontSize:'28px',color:'var(--navy)'}}>Donate Form</h2>
              <p className="text-sm" style={{color:'var(--muted)'}}>Fill in your details to proceed with your donation</p>
            </div>

            <form onSubmit={submit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {fields.filter(f => f.half).map(f => (
                  <div key={f.name}>
                    <label className="block text-xs font-medium mb-1.5 tracking-wide" style={{color:'var(--navy)'}}>{f.label}</label>
                    <input type={f.type} name={f.name} value={form[f.name]} onChange={handle}
                      placeholder={f.placeholder} required={f.required} className="sb-input"/>
                    {errors[f.name] && <p className="text-xs mt-1" style={{color:'#e53e3e'}}>{errors[f.name]}</p>}
                  </div>
                ))}
              </div>
              {fields.filter(f => !f.half).map(f => (
                <div key={f.name}>
                  <label className="block text-xs font-medium mb-1.5 tracking-wide" style={{color:'var(--navy)'}}>{f.label}</label>
                  <textarea name={f.name} value={form[f.name]} onChange={handle}
                    placeholder={f.placeholder} required={f.required} rows="3"
                    className="sb-input" style={{resize:'vertical'}}/>
                  {errors[f.name] && <p className="text-xs mt-1" style={{color:'#e53e3e'}}>{errors[f.name]}</p>}
                </div>
              ))}
              <button type="submit" className="w-full text-white py-3.5 rounded-full font-semibold text-sm transition-all hover:-translate-y-0.5 mt-2"
                style={{background:'var(--saffron)',boxShadow:'0 6px 20px rgba(232,103,10,0.3)'}}>
                Submit & Proceed to Payment
              </button>
              <p className="text-xs text-center" style={{color:'var(--muted)'}}>*For submission of 80G please contact us</p>
            </form>
          </div>
        </div>
      </section>
    </div>
  )
}
